import React, { useEffect, useState } from "react";
import styled from "styled-components";
import firebase from "gatsby-plugin-firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import { FirebaseProps, setDataToFirestore, withFirebase } from "@lib/firebase";
import { useCheckScreenWidth, usePrevious } from "@util/hooks";
import { useStore } from "@state/store";
import { colorsRGB, icons, TABLET_BREAKPOINT } from "@util/constants";
import { Container, P } from "@util/standard";
import LoginForm from "@components/auth/loginForm";
import { setUser, setUserDetails } from "@util/helper";
import { toast } from "react-toastify";

const StyledButton = styled.button<{ height?: string; width?: string }>`
  border: none;
  background: transparent;
  cursor: pointer;
  img {
    width: 46px;
    height: 46px;
    ${({ height }) => height && `height: ${height};`};
    ${({ width }) => width && `width: ${width};`};
  }
`;

const Close = styled.img`
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
`;

function SignInGoogle(props: FirebaseProps) {
  const auth = props.firebase.auth();

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth
      .signInWithPopup(provider)
      .then(result => {
        if (result == null) {
          return;
        }
        const userName = result.user?.displayName?.split(" ");

        if (userName == null) {
          return;
        }
        console.log(result);

        const userData = {
          firstName: userName[0],
          lastName: userName[1],
          name: result.user?.displayName,
          email: result.user?.email as string,
          profilePic: result.user?.photoURL,
          uid: result.user?.uid as string,
        };

        // this object requires token to fix the typing
        setTimeout(() => {
          setUserDetails(userData);
          setUser(result.user?.uid as string);
        }, 100);
      })
      .then(result => toast.success("Succesfully Signed In"))
      .catch(error => {
        console.log(error);
        toast.error("There was an problem when trying to sign in");
      });
  };

  return (
    <StyledButton height="53px" width="53px" onClick={signInWithGoogle}>
      <img src={icons.googleSignIn} />
    </StyledButton>
  );
}

function SignInFacebook(props: FirebaseProps) {
  const auth = props.firebase.auth();

  const signInWithFacebook = () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    auth
      .signInWithPopup(provider)
      .then(result => {
        if (result == null) {
          return;
        }
        console.log(result);

        const userName = result.user?.displayName?.split(" ");

        if (userName == null) {
          return;
        }

        const userData = {
          firstName: userName[0],
          lastName: userName[1],
          name: result.user?.displayName,
          email: result.user?.email as string,
          profilePic: result.user?.photoURL,
          uid: result.user?.uid as string,
        };

        // this object requires token to fix the typing
        setTimeout(() => {
          setUserDetails(userData);
          setUser(result.user?.uid as string);
        }, 100);
      })
      .then(result => toast.success("Succesfully Signed In"))
      .catch(error => {
        console.log(error);
        toast.error("There was an problem when trying to sign in");
      });
  };

  return (
    <StyledButton onClick={signInWithFacebook}>
      <img src={icons.facebookSignIn} />
    </StyledButton>
  );
}

function SignOut(props: FirebaseProps) {
  const auth = props.firebase.auth();
  const handleSignOut = () => {
    auth.signOut();
    useStore.setState({ user: undefined, isLoggedIn: false, savedBlogs: [], savedRecipes: [] });
  };
  return (
    auth.currentUser && (
      <button className="sign-out" onClick={() => handleSignOut()}>
        Sign Out
      </button>
    )
  );
}

const SignInGoogleWithFirebase = withFirebase(SignInGoogle);
const SignOutWithFirebase = withFirebase(SignOut);
const SignInFacebookWithFirebase = withFirebase(SignInFacebook);

function Auth({ firebase }: FirebaseProps) {
  if (firebase == null || withFirebase == null) {
    return null;
  }

  const auth = firebase.auth();
  const [authUser] = useAuthState(auth);
  const prevAuthUser = usePrevious(authUser);
  const firestore = firebase.firestore();

  useEffect(() => {
    if (prevAuthUser == null && authUser) {
      const firestoreData = {
        firestore,
        name: authUser.displayName,
        email: authUser.email,
        uid: authUser.uid,
      };

      setDataToFirestore(firestoreData);
      setUser(authUser.uid);
      return;
    }
    if (prevAuthUser && authUser == null) {
      useStore.setState({ user: undefined, savedRecipes: [], savedBlogs: [] });
    }

    if (authUser) {
      setUser(authUser.uid);
    }
  }, [authUser]);

  const { authMenuOpen, createAccountFormOpen } = useStore();
  const { isLaptopWidth } = useCheckScreenWidth();

  return (
    <Container
      width={authMenuOpen ? "100vw" : "0"}
      height="100vh"
      position="absolute"
      top="0px"
      left="0px"
      zIndex={authMenuOpen ? 999 : 0}
      opacity={authMenuOpen ? 1 : 0}
    >
      {/* {authMenuOpen && ( */}
      <Container
        width={isLaptopWidth ? "42%" : "100%"}
        height={isLaptopWidth ? "100vh" : ""}
        backgroundColor="white"
        position="fixed"
        right={isLaptopWidth ? "0px" : undefined}
        left={isLaptopWidth ? undefined : "0px"}
        top={isLaptopWidth ? "0px" : undefined}
        translateX={authMenuOpen ? "0%" : "100%"}
        transitionAll={0.2}
        flexDirection="column"
      >
        <Close
          src={icons.closeDark}
          onClick={() => useStore.setState({ authMenuOpen: false, createAccountFormOpen: false })}
        />

        <Container
          width={isLaptopWidth ? "60%" : "76%"}
          margin="20px auto 0 auto"
          flexDirection="column"
          padding="80px 0 60px 0"
          mobileMargin="10px auto 0 auto"
        >
          <LoginForm />
          {authUser ? (
            <div>
              {/* {authUser ? authUser.displayName : "Error"} */}
              {/* <SignOutWithFirebase /> */}
            </div>
          ) : (
            <>
              <P>{createAccountFormOpen ? "OR SIGNUP WITH" : "OR LOG IN WITH"}</P>
              <Container>
                <SignInGoogleWithFirebase />
                <SignInFacebookWithFirebase />
              </Container>
            </>
          )}
        </Container>
      </Container>
      {/* )} */}

      {authMenuOpen && <Container width="100%" height="100%" backgroundRGBColor={colorsRGB.black(0.8)}></Container>}
    </Container>
  );
}

export default withFirebase(Auth);
